import { render, staticRenderFns } from "./ArborescenceFolder.vue?vue&type=template&id=dcef8622&scoped=true&"
import script from "./ArborescenceFolder.vue?vue&type=script&lang=js&"
export * from "./ArborescenceFolder.vue?vue&type=script&lang=js&"
import style0 from "./ArborescenceFolder.vue?vue&type=style&index=0&id=dcef8622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcef8622",
  null
  
)

export default component.exports